import { PageEnum } from "@/enums/pageEnum";
import { TK } from "@/utils/tracker";
import { ref } from "vue";
import { throttle } from '@/utils'

export function useMouseMove() {
    const deltaX = ref(0);
    const deltaY = ref(0);
    const isMouseDown = ref(false);
    const lastPoint = ref({ x: 0, y: 0 });
    const scale = 100;
    const throttleTK = throttle(TK, 500);

    const delayDeltaX = ref(0);
    function updateDelayDeltaX() {
        const diff = deltaX.value - delayDeltaX.value;
        delayDeltaX.value += diff * 0.03;
    }

    function setDeltaX(x: number) {
        deltaX.value = x;
    }

    function setDeltaY(y: number) {
        deltaY.value = y;
    }

    window.addEventListener('pointerdown', e => {
        isMouseDown.value = true;
        lastPoint.value.x = e.pageX;
        lastPoint.value.y = e.pageY;
    });

    window.addEventListener('pointerup', e => {
        isMouseDown.value = false;
    });

    window.addEventListener('pointermove', e => {
        if (!isMouseDown.value) return;
        throttleTK('scan_screen_slide', PageEnum.BALL);
        setDeltaX((e.clientX - lastPoint.value.x) / scale);
        setDeltaY((e.clientY - lastPoint.value.y) / scale);
        lastPoint.value.x = e.clientX;
        lastPoint.value.y = e.clientY;
    });

    return { deltaX, deltaY, isMouseDown, setDeltaX, setDeltaY, updateDelayDeltaX, delayDeltaX };
}